import { useState, useEffect, useCallback } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getSalesTeamUsers } from '../api'

export const useGetSalesTeamUsers = (id?: number) => {
  const dispatch = useAppDispatch()

  const [teamId, setTeamId] = useState(id)
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const execute = useCallback((id: number) => setTeamId(id), [])

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        if (!!teamId) {
          setStatus('pending')
          const result = await dispatch(getSalesTeamUsers(teamId))

          if (mounted) {
            if (getSalesTeamUsers.fulfilled.match(result)) {
              setStatus('success')
            } else {
              setStatus('fail')
            }
          }
        }
      } catch (error) {
        if (mounted) setStatus('fail')
      } finally {
        if (mounted) {
          setStatus('idle')
          setTeamId(undefined)
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, teamId])

  return { status, execute }
}
